import type { HTMLAttributes, ReactNode } from 'react';
import { Badge } from 'reactstrap';

export type BadgeTone = 'neutral' | 'success' | 'warn' | 'danger' | 'info' | 'primary';

export interface StatusBadgeProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'className'> {
  tone?: BadgeTone;
  className?: string;
  children: ReactNode;
}

// Map the VP semantic tone onto a reactstrap/Bootstrap badge colour.
const TONE_COLOR: Record<BadgeTone, string> = {
  neutral: 'secondary',
  success: 'success',
  warn: 'warning',
  danger: 'danger',
  info: 'info',
  primary: 'primary',
};

/**
 * Status pill. Public API unchanged (`tone` / `className` / passthrough html
 * attrs / children); rendering migrated from the bespoke `vp-badge` classes to
 * reactstrap `<Badge>` (Velzon look).
 */
export function StatusBadge({ tone = 'neutral', className, children, ...rest }: StatusBadgeProps) {
  return (
    <Badge color={TONE_COLOR[tone]} className={className} {...rest}>
      {children}
    </Badge>
  );
}
